type SeonSdkWithSessionMethods = {
  init: (options: {
    behavioralDataCollection: {
      formFilloutDurationTargetId: string;
    };
  }) => void;
  getSession: (options?: Record<string, unknown>) => Promise<string>;
};

let seonSdkPromise: Promise<SeonSdkWithSessionMethods | undefined> | null = null;
let isSeonInitialized = false;

async function getSeonSdk() {
  if (typeof window === 'undefined') {
    return undefined;
  }

  if (!seonSdkPromise) {
    seonSdkPromise = import('@seontechnologies/seon-javascript-sdk')
      .then(module => module.default as SeonSdkWithSessionMethods)
      .catch(() => undefined);
  }

  return seonSdkPromise;
}

export async function initSeonSdk() {
  const seonSdk = await getSeonSdk();
  if (!seonSdk || isSeonInitialized) {
    return;
  }

  seonSdk.init({
    behavioralDataCollection: {
      formFilloutDurationTargetId: 'register-form',
    },
  });
  isSeonInitialized = true;
}

export async function getSeonSessionId() {
  const seonSdk = await getSeonSdk();
  if (!seonSdk) {
    return undefined;
  }

  if (!isSeonInitialized) {
    await initSeonSdk();
  }

  return seonSdk.getSession();
}
